import { Component } from '@theme/component';

class CardCarousel extends Component {
  requiredRefs = ['cardCarouselSwiper'];

  #swiper = null;

  connectedCallback() {
    super.connectedCallback();
    this.#initSwiper();
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.#swiper?.destroy(true, true);
  }

  #initSwiper() {
    if (!this.refs.cardCarouselSwiper) {
      return;
    }

    const layoutMobile = this.dataset.slidesPerViewMobile;
    const slidesPerViewMobile = layoutMobile === 'one' ? 1.1 : 2.12;
    const spaceBetweenMobile = layoutMobile === 'two' ? 12 : 20;

    this.#swiper = new window.Swiper(this.refs.cardCarouselSwiper, {
      loop: true,
      allowTouchMove: true,

      slidesPerView: slidesPerViewMobile,
      spaceBetween: spaceBetweenMobile,

      breakpoints: {
        769: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
      },
    });
  }

  slideNext() {
    this.#swiper?.slideNext();
  }

  slidePrev() {
    this.#swiper?.slidePrev();
  }
}

if (!customElements.get('card-carousel')) {
  customElements.define('card-carousel', CardCarousel);
}